import { useEffect, useState } from 'react';

type Subscribable = {
  subscribe: (callback: () => void) => () => void;
};

export function useSubscribe<T extends Subscribable>(subscribable: T): void {
  const [, setTick] = useState(0);

  useEffect(() => {
    const unsubscribe = subscribable.subscribe(() => {
      setTick(tick => tick + 1);
    });

    return () => {
      unsubscribe();
    };
  }, [subscribable]);
}
